import { render, staticRenderFns } from "./dangerLayout.vue?vue&type=template&id=5a5c5dde&scoped=true"
import script from "./dangerLayout.vue?vue&type=script&lang=js"
export * from "./dangerLayout.vue?vue&type=script&lang=js"
import style0 from "./dangerLayout.vue?vue&type=style&index=0&id=5a5c5dde&lang=sass"
import style1 from "./dangerLayout.vue?vue&type=style&index=1&id=5a5c5dde&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c5dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5c5dde')) {
      api.createRecord('5a5c5dde', component.options)
    } else {
      api.reload('5a5c5dde', component.options)
    }
    module.hot.accept("./dangerLayout.vue?vue&type=template&id=5a5c5dde&scoped=true", function () {
      api.rerender('5a5c5dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerLayout.vue"
export default component.exports